import * as ReactI18next from 'react-i18next';

export var Trans = process.env.REACT_APP_SHOW_I18N_VIZ === 'true' ? require('./').withI18nViz(function (props) {
  return {
    id: props.i18nKey,
    description: props.description
  };
})(ReactI18next.Trans) : ReactI18next.Trans;


//////////////////
// WEBPACK FOOTER
// ../lib/react-i18next.js
// module id = 130
// module chunks = 0